import { Injectable, InjectionToken } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Gif } from "./gif.types";
import { catchError, of } from "rxjs";
import { LoggerService } from "@teammood/shared/util/logger";

export const GIF_PROVIDER_ID = new InjectionToken<string>('gifProvider');

@Injectable()
export class GifsService {

    constructor(private http: HttpClient, private logger: LoggerService) { }

    getTrending() {
        return this.http.get<Gif[]>('/api/gif/trending').pipe(
            catchError(err => {
                this.logger.error('unable to get Gif trends', err);
                return of([])
            })
        );
    }

    search(params: { q: string; }) {
        return this.http.get<Gif[]>('/api/gif/search', { params: params }).pipe(
            catchError(err => {
                this.logger.error('unable to search Gif', err);
                return of([])
            })
        );
    }

    registerShare(params: { q: string; id: string; }) {
        return this.http.get<void>('/api/gif/registershare', { params: params });
    }
}
